// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-module--footer--182z9","grid":"index-module--grid--2ogN1","title":"index-module--title--3Ys5r","waves":"index-module--waves--1AZ5A"};